"use client";
import Card from "@/common/Card";
import TopSaleSkeleton from "@/components/Skeleton/TopSaleSkeleton";
import { getSearchProducts } from "@/services/productService";
import { ProductType } from "@/types/productType";
import { useMutation } from "@tanstack/react-query";
import Link from "next/link";
import React, { useCallback, useEffect, useState } from "react";
import { Autoplay, Keyboard, Mousewheel, Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

function TopSale() {
  const { isPending, mutateAsync: getProductsItem } = useMutation({
    mutationFn: getSearchProducts,
    retry: 2,
    retryDelay: 1000,
  });
  const [productData, setProductData] = useState<ProductType[]>([]);

  const getAllMostSaleData = useCallback(async () => {
    try {
      const response = await getProductsItem({
        take: 8,
        mostSold: true,
      });
      if (response?.success) {
        setProductData(response?.products);
      }
    } catch (err) {
      console.log("error in fetch all data for last offers ", err);
    }
  }, [getProductsItem]);
  useEffect(() => {
    getAllMostSaleData();
  }, [getAllMostSaleData]);

  return (
    <>
      <div className="flex items-center gap-4 mx-6 lg:mx-16 my-5 lg:mt-20 ">
        <h2 className="text-2xl  lg:text-3xl text-ws-gray-800 font-bold">
          پرفروش‌ترین‌ها
        </h2>
      </div>
      <div className="rounded-3xl flex items-center flex-col  ">
        <div className="cards-wrapper-top-sale flex gap-3 justify-end">
          <Swiper
            cssMode={true}
            navigation={true}
            mousewheel={true}
            loop={false}
            autoplay={{
              delay: 2500,
              pauseOnMouseEnter: true,
            }}
            keyboard={true}
            modules={[Navigation, Mousewheel, Keyboard, Autoplay]}
            slidesPerView={3}
            breakpoints={{
              320: {
                slidesPerView: 2,
                spaceBetween: 20,
              },
              480: {
                slidesPerView: 1.5,
                spaceBetween: 40,
              },
              640: {
                slidesPerView: 2,
                spaceBetween: 40,
              },
              768: {
                slidesPerView: 2.5,
                spaceBetween: 40,
              },
              870: {
                slidesPerView: 2,
                spaceBetween: 40,
              },
              980: {
                slidesPerView: 2.5,
                spaceBetween: 40,
              },
              1024: {
                slidesPerView: 2.7,
                spaceBetween: 40,
              },
              1100: {
                slidesPerView: 3,
                spaceBetween: 40,
              },
              1280: {
                slidesPerView: 3.5,
                spaceBetween: 40,
              },
              1400: {
                slidesPerView: 4,
                spaceBetween: 40,
              },
            }}
          >
            {isPending ? (
              <TopSaleSkeleton />
            ) : (
              productData?.map((product, index) => (
                <SwiperSlide key={index + 1}>
                  <Card
                    classNameImage="top-sale-class-image"
                    className="top-sale-class"
                    {...product}
                  />
                </SwiperSlide>
              ))
            )}
          </Swiper>
        </div>
        <div className="self-start flex flex-col justify-between h-full w-full">
          <Link
            className=" text-ws-gray-500 text-center mt-5 text-xl"
            href="/topSaleList"
          >
            <span className="underline underline-offset-[6px]	">بیشتر</span>
          </Link>
        </div>
      </div>
    </>
  );
}

export default TopSale;
